export default __webpack_public_path__ + "static/media/9.6ed7d641.png";